import React, { useState } from "react";
import { useQuery } from "@apollo/react-hooks";
import { Radio } from "antd";

import { SEARCH_HASHTAGS } from 'graphql/query/search-gql';

import { HashtagList } from "components/hashtag";
import {LoadMoreOnScroll, Localize} from "components/service";
import { errorNotification, Loader } from "components/result";


const SearchHashtags = (props) => {

    const { query, onlyQuery, sortBy = 'CREATED_AT' } = props;

    const [ sortField, setSortField ] = useState( sortBy );

    const {loading, data, fetchMore} = useQuery(SEARCH_HASHTAGS, {
        variables: {
            text : query,
            orderBy: [{
                column: sortField,
                order: "DESC"
            }]
        },
        fetchPolicy:"cache-and-network",
        notifyOnNetworkStatusChange: true
    });

    const {
        searchHashtags : {
            pageInfo,
            edges : hashtags
        } = {}
    } = data !== undefined ? data : {};

    const fetchMoreAction = () => {

        if( !loading && pageInfo.hasNextPage){

            fetchMore({
                variables: {
                    endCursor : pageInfo.endCursor
                },
                updateQuery: (previousResult, { fetchMoreResult }) => {

                    const searchHashtags = fetchMoreResult.searchHashtags;

                    const newSearchResults = {
                        searchHashtags: {
                            edges : [
                                ...hashtags,
                                ...searchHashtags.edges
                            ],
                            __typename: searchHashtags.__typename,
                            pageInfo : searchHashtags.pageInfo
                        }
                    };

                    return searchHashtags.edges.length ? newSearchResults : previousResult;

                }
            }).catch((error) => {
                errorNotification(error);
            });
        }
    };

    if(onlyQuery){
        return {loading, data, fetchMoreAction};
    }

    return(
        <>
            { data !== undefined && pageInfo.total > 0 &&
            <>
                <div className="search-sort-and-view border-color-light">
                    <div className="search-sort">
                        <Radio.Group
                            onChange={
                                (e) => { setSortField(e.target.value) }
                            }
                            defaultValue={ sortField }
                        >
                            <Radio.Button value="CREATED_AT">
                                <Localize>SORT.Label_Newest</Localize>
                            </Radio.Button>
                            <Radio.Button value="COUNT_FOLLOWERS">
                                <Localize>SORT.Label_Popular</Localize>
                            </Radio.Button>
                            <Radio.Button value="COUNT_POSTS">
                                <Localize>SORT.Label_MostUsed</Localize>
                            </Radio.Button>
                        </Radio.Group>
                    </div>
                </div>
                <HashtagList
                    hashtags={ hashtags }
                />
                { pageInfo.hasNextPage &&
                    <LoadMoreOnScroll
                        fetchAction={() => fetchMoreAction()}
                        loading={ false }
                    />
                }
            </>
            }
            { !loading && data !== undefined && pageInfo.total === 0  &&
                <div className="search-result-not-found">
                    <Localize br={ <br /> } wrap="h3">NO_DATA.Text_Search_Hashtags</Localize>
                </div>
            }
            { loading && <Loader /> }
        </>
    );
};

export default SearchHashtags;